<div class="modal-header d-flex justify-content-between">
    <h5 class="modal-title d-flex align-items-center">
        <i class="bx bx-book me-1 font-20 text-primary"></i>{{journalForm.value.id ? 'Update' : 'Add'}} Journal
    </h5>
    <button type="button" class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close"
        (click)="activeModal.close('Close')"></button>
</div>
<div class="modal-body">
    <form [formGroup]="journalForm" (ngSubmit)="saveJournal(inProgresss)"
        class="d-flex align-items-center flex-wrap g-3">
        <div class="col-md-4 me-3">
            <label for="particular" class="form-label">Particular <b class="text-secondary">*</b></label>
            <div class="input-group">
                <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-briefcase'></i></span>
                <input type="text" class="form-control ps-1" id="label" placeholder="Enter particular" ngbAutofocus
                    [ngClass]="{'is-invalid': submitted && f.particular.errors}" formControlName="particular"
                    [readonly]="journalForm.get('payable')?.value === true" autocomplete="off" />
                <div class="invalid-feedback" *ngIf="submitted && f.particular.errors">
                    <span *ngIf="f.particular.errors.required">Please enter a valid particular..</span>
                    <span *ngIf="f.particular.errors.pattern">Only letters are allowed.</span>
                </div>
            </div>
        </div>
        <div class="col-md-4 me-3">
            <label for="date" class="form-label">Date <b class="text-secondary">*</b></label>
            <div class="input-group">
                <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-calendar'></i></span>
                <input type="date" class="form-control" id="date" formControlName="date"
                    [readonly]="journalForm.get('payable')?.value === true"
                    [ngClass]="{'is-invalid': submitted && f.date.errors}">
                <div class="invalid-feedback" *ngIf="submitted && f.date.errors">
                    <span *ngIf="f.date.errors.required">Please select a date.</span>
                </div>
            </div>
        </div>
        <div class="modal-footer border-0 mt-4">
            <button type="submit" class="btn btn-secondary" #inProgresss
                [disabled]="journalForm.get('payable')?.value === true"
                [ngClass]="{'no-event':inProgresss?.value=='true'}">
                <ng-container *ngIf="inProgresss?.value=='true'">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    {{journalForm.value.id ? 'Updating...' : 'Saving...'}}
                </ng-container>
                <ng-container *ngIf="inProgresss?.value!='true'">
                    <i class="bx bx-save size"></i>{{journalForm.value.id ? 'Save Changes' : 'Save'}}
                </ng-container>
            </button>
        </div>
    </form>
</div>
<div class="container mt-3" *ngIf="journalForm?.value?.id">
    <form [formGroup]="transationForm">
        <div class="row g-3 p-3 card-size">
            <div class="col-md-6 bg-light p-3">
                <div class="card custom-shadow scroll-card">
                    <div class="card-body">
                        <h5 class="card-title card-br-b mb-4">By</h5>
                        <div class="table-container">
                            <table class="table table-bordered" id="table">
                                <thead id="table-thead">
                                    <tr class="bg-light sticky-header">
                                        <th scope="col" width="200">Account</th>
                                        <th scope="col" width="200">Amount</th>
                                        <th scope="col" width="120" class="text-center">Actions</th>
                                    </tr>
                                </thead>
                                <tbody formArrayName="byTransations">
                                    <tr *ngFor="let byTransation of byTransations.controls; let i=index"
                                        [formGroupName]="i">
                                       
                                        <td>
                                            <ng-select placeholder="Select account" formControlName="accountId"
                                                [clearable]="true" [searchable]="false"
                                                [readonly]="journalForm.get('payable')?.value === true"
                                                [ngClass]="{'is-invalid': byTransation.get('accountId')?.invalid && (byTransation.get('accountId')?.dirty || byTransation.get('accountId')?.touched)}">
                                                <ng-option *ngFor="let account of accounts; trackBy: trackByIndex"
                                                    [value]="account.id" [disabled]="disableByAccount(account.id)">
                                                    {{ account.name }}
                                                </ng-option>
                                            </ng-select>
                                            <small class="form-text text-muted danger"
                                                *ngIf="byTransation.get('accountId')?.invalid && (byTransation.get('accountId')?.dirty || byTransation.get('accountId')?.touched)">
                                                Please select a valid account.
                                            </small>
                                        </td>
                                        <td>
                                            <input type="number" class="form-control" formControlName="amount"
                                                placeholder="Amount" required
                                                [readonly]="journalForm.get('payable')?.value === true"
                                                [ngClass]="{'is-invalid': byTransation.get('amount')?.invalid && (byTransation.get('amount')?.dirty || byTransation.get('amount')?.touched)}">
                                            <small class="form-text text-muted danger"
                                                *ngIf="byTransation.get('amount')?.invalid && (byTransation.get('amount')?.dirty || byTransation.get('amount')?.touched)">
                                                <span *ngIf="byTransation.get('amount')?.errors?.required">Please enter
                                                    a
                                                    valid amount.</span>
                                                <span *ngIf="byTransation.get('amount')?.errors?.min">Amount must be
                                                    greater
                                                    than {{ minAmount }}.</span>
                                            </small>
                                        </td>
                                        <td class="text-center">
                                            <div class="d-flex justify-content-center align-items-center mt-1">
                                                <button type="button" class="btn btn-secondary btn-sm me-2"
                                                    [disabled]="journalForm.get('payable')?.value === true"
                                                    title="Add by transaction" *ngIf="i === byTransations.length - 1"
                                                    (click)="pushByTransation(byTransation.value)">
                                                    <i class="bx bx-plus"></i>
                                                </button>
                                                <button type="button" class="btn btn-danger btn-sm"
                                                    [disabled]="journalForm.get('payable')?.value === true"
                                                    *ngIf="byTransations.length > 1">
                                                    <i class="bx bx-trash" title="Delete By Transation"
                                                        (click)="deleteByTransation(i,byTransation.value)"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="total">
                            <strong>Total By: {{ totalByAmount | currency: 'INR':'symbol':'1.2-2' || 'Nil'
                                }}</strong>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 bg-light p-3">
                <div class="card custom-shadow scroll-card">
                    <div class="card-body">
                        <h5 class="card-title card-br-b mb-4">To</h5>
                        <div class="table-container">
                            <table class="table table-bordered" id="table">
                                <thead id="table-thead">
                                    <tr class="bg-light sticky-header">
                                        <th scope="col" width="200">Account</th>
                                        <th scope="col" width="200">Amount</th>
                                        <th scope="col" width="120" class="text-center">Actions</th>
                                    </tr>
                                </thead>
                                <tbody formArrayName="toTransations">
                                    <tr *ngFor="let toTransation of toTransations.controls; let i=index"
                                        [formGroupName]="i">
                                      
                                        <td>
                                            <ng-select placeholder="Select account" formControlName="accountId"
                                                [clearable]="true" [searchable]="false"
                                                [readonly]="journalForm.get('payable')?.value === true"
                                                [ngClass]="{'is-invalid': toTransation.get('accountId')?.invalid && (toTransation.get('accountId')?.dirty || toTransation.get('accountId')?.touched)}">
                                                <ng-option *ngFor="let account of accounts; trackBy: trackByIndex"
                                                    [value]="account.id" [disabled]="disableToAccount(account.id)">
                                                    {{ account.name }}
                                                </ng-option>
                                            </ng-select>
                                            <small class="form-text text-muted danger"
                                                *ngIf="toTransation.get('accountId')?.invalid && (toTransation.get('accountId')?.dirty || toTransation.get('accountId')?.touched)">
                                                Please select a valid account.
                                            </small>
                                        </td>
                                        <td>
                                            <input type="number" class="form-control" formControlName="amount"
                                                placeholder="Amount" required
                                                [readonly]="journalForm.get('payable')?.value === true"
                                                [ngClass]="{'is-invalid': toTransation.get('amount')?.invalid && (toTransation.get('amount')?.dirty || toTransation.get('amount')?.touched)}">
                                            <small class="form-text text-muted danger"
                                                *ngIf="toTransation.get('amount')?.invalid && (toTransation.get('amount')?.dirty || toTransation.get('amount')?.touched)">
                                                <span *ngIf="toTransation.get('amount')?.errors?.required">Please enter
                                                    a
                                                    valid amount.</span>
                                                <span *ngIf="toTransation.get('amount')?.errors?.min">Amount must be
                                                    greater
                                                    than {{ minAmount }}.</span>
                                            </small>
                                        </td>
                                        <td class="text-center">
                                            <div class="d-flex justify-content-center align-items-center mt-1">
                                                <button type="button" class="btn btn-secondary btn-sm me-2"
                                                    [disabled]="journalForm.get('payable')?.value === true"
                                                    title="add to transaction" *ngIf="i === toTransations.length - 1"
                                                    (click)="pushToTransation(toTransation.value)">
                                                    <i class="bx bx-plus"></i>
                                                </button>
                                                <button type="button" class="btn btn-danger btn-sm"
                                                    [disabled]="journalForm.get('payable')?.value === true"
                                                    *ngIf="toTransations.length > 1">
                                                    <i class="bx bx-trash" title="Delete To Transation"
                                                        (click)="deleteToTransation(i,toTransation.value)"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="total">
                            <strong>Total To: {{ totalToAmount | currency: 'INR':'symbol':'1.2-2' || 'Nil'
                                }}</strong>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer btn-footer border-0">
                <button type="submit" class="btn btn-secondary" #inProgress (click)="saveTransation()"
                    [ngClass]="{'no-event':inProgress?.value=='true'}"
                    [disabled]="journalForm.get('payable')?.value === true">
                    <ng-container *ngIf="inProgress?.value=='true'">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        {{hasTransationId ? 'Updating...' : 'Saving...'}}
                    </ng-container>
                    <ng-container *ngIf="inProgress?.value!='true'">
                        <i class="bx bx-save size"></i>{{hasTransationId?'Save Changes':'Save'}}
                    </ng-container>
                </button>
                <button type="button" class="btn btn-secondary" (click)="onPayButtonClick()"
                    [disabled]="!hasTransationId || journalForm.get('payable')?.value === true">
                    <ng-container>
                        <i class="bx bx-credit-card size"></i>Proceed
                    </ng-container>
                </button>
            </div>
        </div>
    </form>
</div>
<div class="modal-header d-flex justify-content-between" *ngIf="journalForm.get('payable')?.value === true">
    <h5 class="modal-title d-flex align-items-center">
        <i class="bx bx-book me-1 font-20 text-primary"></i>
        {{ payForm.value.id ? 'Update' : 'Add' }} Payment
    </h5>
</div>
<div class="modal-body" *ngIf="journalForm.get('payable')?.value === true">
    <form [formGroup]="payForm" (ngSubmit)="savePayment(inProgress)" class="d-flex align-items-center">
        <div class="col-md-4 me-3">
            <label for="date" class="form-label"> Payment Date <b class="text-secondary">*</b></label>
            <div class="input-group">
                <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-calendar'></i></span>
                <input type="date" class="form-control" id="date" formControlName="date" [readonly]="!hasTransationId"
                    required>
                <div class="invalid-feedback" *ngIf="submittedPayment && w.date.errors">
                    <span *ngIf="w.date.errors.required">Please select a date.</span>
                </div>
            </div>
        </div>
        <div class="modal-footer border-0 mt-4">
            <button type="submit" class="btn btn-secondary" #inProgress [disabled]="!hasTransationId"
                [ngClass]="{'no-event':inProgress?.value=='true'}">
                <ng-container *ngIf="inProgress?.value=='true'">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    {{payForm.value.id ||hasPaymentId? 'Updating...' : 'Saving...'}}
                </ng-container>
                <ng-container *ngIf="inProgress?.value!='true'">
                    <i class="bx bx-save size"></i>{{payForm.value.id||hasPaymentId ? 'Save Changes' :
                    'Save'}}
                </ng-container>
            </button>
        </div>
    </form>
</div>
<div class="container mt-3" *ngIf="payForm?.value?.id">
    <form [formGroup]="paymentForm">
        <div class="row g-3 p-3 card-size">
            <div class="col-md-6 bg-light p-3">
                <div class="card custom-shadow scroll-card">
                    <div class="card-body">
                        <h5 class="card-title card-br-b mb-4">By</h5>
                        <div class="table-container">
                            <table class="table table-bordered" id="table">
                                <thead id="table-thead">
                                    <tr class="bg-light sticky-header">
                                        <th scope="col" width="200">Account</th>
                                        <th scope="col" width="200">Amount</th>
                                    </tr>
                                </thead>
                                <tbody formArrayName="byPayments">
                                    <tr *ngFor="let byPayment of byPayments.controls; let i=index" [formGroupName]="i">
                                        <td>
                                            <ng-select class="form-control rcx-ng-select" placeholder="Select account"
                                                [clearable]="true" [searchable]="false" [readonly]="true"
                                                formControlName="accountId"
                                                [ngClass]="{'is-invalid': submittedByPayment && byPayment.get('accountId')?.errors}">
                                                <ng-option *ngFor="let account of accounts"
                                                    [value]="account.id">{{account.name}}</ng-option>
                                            </ng-select>
                                        </td>
                                        <td>
                                            <input type="number" class="form-control" placeholder="Amount" required
                                                formControlName="amount" readonly>
                                            <div class="invalid-feedback">
                                                Please enter a valid amount.
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="total">
                            <strong>Total By: {{ totalByAmountPayment | currency: 'INR':'symbol':'1.2-2' || 'Nil'
                                }}</strong>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 bg-light p-3">
                <div class="card custom-shadow scroll-card">
                    <div class="card-body">
                        <h5 class="card-title card-br-b mb-4">To</h5>
                        <div class="table-container">
                            <table class="table table-bordered" id="table">
                                <thead id="table-thead">
                                    <tr class="bg-light sticky-header">
                                        <th scope="col" width="200">Account</th>
                                        <th scope="col" width="200">Amount</th>
                                        <th scope="col" width="120" class="text-center">Actions</th>
                                    </tr>
                                </thead>
                                <tbody formArrayName="toPayments">
                                    <tr *ngFor="let toPayment of toPayments.controls; let i=index" [formGroupName]="i">
                                       
                                        <td>
                                            <ng-select placeholder="Select account" formControlName="accountId"
                                                [readonly]="!hasPaymentIds" [clearable]="true" [searchable]="false"
                                                [ngClass]="{'is-invalid': toPayment.get('accountId')?.invalid && (toPayment.get('accountId')?.dirty || toPayment.get('accountId')?.touched)}">
                                                <ng-option *ngFor="let account of accounts; trackBy: trackByIndex"
                                                    [value]="account.id" [disabled]="disableAccountPayment(account.id)">
                                                    {{ account.name }}
                                                </ng-option>
                                            </ng-select>
                                            <small class="form-text text-muted danger"
                                                *ngIf="toPayment.get('accountId')?.invalid && (toPayment.get('accountId')?.dirty || toPayment.get('accountId')?.touched)">
                                                Please select a valid account.
                                            </small>
                                        </td>
                                        <td>
                                            <input type="number" class="form-control" formControlName="amount" (keyup)="checkPaymentAmounts()"
                                                [readonly]="!hasPaymentIds" placeholder="Amount" required
                                                [ngClass]="{'is-invalid': toPayment.get('amount')?.invalid && (toPayment.get('amount')?.dirty || toPayment.get('amount')?.touched)}">
                                            <small class="form-text text-muted danger"
                                                *ngIf="toPayment.get('amount')?.invalid && (toPayment.get('amount')?.dirty || toPayment.get('amount')?.touched)">
                                                <span *ngIf="toPayment.get('amount')?.errors?.required">Please enter a
                                                    valid
                                                    amount.</span>
                                                <span *ngIf="toPayment.get('amount')?.errors?.min">Amount must be
                                                    greater
                                                    than {{ minAmount }}.</span>
                                            </small>
                                        </td>
                                        <td class="text-center">
                                            <div class="d-flex justify-content-center align-items-center mt-1">
                                                <button type="button" class="btn btn-secondary btn-sm me-2"
                                                    title="Add to payment" *ngIf="i === toPayments.length - 1"
                                                    (click)="pushToPayment(toPayment.value)">
                                                    <i class="bx bx-plus"></i>
                                                </button>
                                                <button type="button" class="btn btn-danger btn-sm"
                                                    *ngIf="toPayments.length > 1">
                                                    <i class="bx bx-trash" title="Delete To Transation"
                                                        (click)="deleteToPayment(i,toPayment.value)"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="total">
                            <strong>Total To: {{ totalToAmountPayment | currency: 'INR':'symbol':'1.2-2' || 'Nil'
                                }}</strong>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer btn-footer border-0">
                <button type="submit" class="btn btn-secondary" #inProgress (click)="upsertPayment()"
                    [ngClass]="{'no-event':inProgress?.value=='true'}">
                    <ng-container *ngIf="inProgress?.value=='true'">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        {{hasToPaymentId ? 'Updating...' : 'Saving...'}}
                    </ng-container>
                    <ng-container *ngIf="inProgress?.value!='true'">
                        <i class="bx bx-save size"></i>{{hasToPaymentId?'Save Changes':'Save'}}
                    </ng-container>
                </button>
            </div>
        </div>
    </form>
</div>